import { defineStore } from 'pinia';
import { actions, getters, state } from '@/stores/methods';

export const useWhatsappMessagesStore = defineStore('whatsappMessages', {
  state: state,
  getters: {
    filterByPhrase: (state) => {
      return (phrase) => state.sortedMessages.filter(m => m.attributes.label.startsWith(phrase) && m.attributes.active === true);
    },
    activeTemplates: (state) => {
      return () => state.sortedMessages.filter(m => m.attributes.active === true);
    },
    sortedMessages(state) {
      return state.collection.sort((a, b) => {
        return b.attributes.label < a.attributes.label ? 1 : -1;
      });
    },
    ...getters,
  },
  actions: actions,
});
